@file:OptIn(InternalResourceApi::class)

package one.devsbox.www.www_portal.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/one.devsbox.www.www_portal.generated.resources/"

@delegate:ResourceContentHash(258_217_201)
internal val Res.string.ui_users_listing_header_identity: StringResource by lazy {
      StringResource("string:ui_users_listing_header_identity", "ui_users_listing_header_identity", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27305, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25889, 60),
      ))
    }

@delegate:ResourceContentHash(1_012_410_401)
internal val Res.string.ui_users_listing_no_users_found: StringResource by lazy {
      StringResource("string:ui_users_listing_no_users_found", "ui_users_listing_no_users_found", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27374, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25950, 99),
      ))
    }

@delegate:ResourceContentHash(-2_042_298_187)
internal val Res.string.ui_users_listing_search_placeholder: StringResource by lazy {
      StringResource("string:ui_users_listing_search_placeholder", "ui_users_listing_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27502, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26050, 63),
      ))
    }

@delegate:ResourceContentHash(549_677_687)
internal val Res.string.ui_users_listing_showing: StringResource by lazy {
      StringResource("string:ui_users_listing_showing", "ui_users_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27574, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26114, 76),
      ))
    }

@delegate:ResourceContentHash(-1_017_529_524)
internal val Res.string.ui_users_splash_desc: StringResource by lazy {
      StringResource("string:ui_users_splash_desc", "ui_users_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27663, 212),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26191, 192),
      ))
    }

@delegate:ResourceContentHash(1_199_172_666)
internal val Res.string.ui_users_splash_title: StringResource by lazy {
      StringResource("string:ui_users_splash_title", "ui_users_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27876, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26384, 53),
      ))
    }

@delegate:ResourceContentHash(-512_368_282)
internal val Res.string.users: StringResource by lazy {
      StringResource("string:users", "users", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27934, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26438, 21),
      ))
    }

@delegate:ResourceContentHash(80_528_753)
internal val Res.string.yes: StringResource by lazy {
      StringResource("string:yes", "yes", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27960, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26460, 15),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("ui_users_listing_header_identity", Res.string.ui_users_listing_header_identity)
  map.put("ui_users_listing_no_users_found", Res.string.ui_users_listing_no_users_found)
  map.put("ui_users_listing_search_placeholder", Res.string.ui_users_listing_search_placeholder)
  map.put("ui_users_listing_showing", Res.string.ui_users_listing_showing)
  map.put("ui_users_splash_desc", Res.string.ui_users_splash_desc)
  map.put("ui_users_splash_title", Res.string.ui_users_splash_title)
  map.put("users", Res.string.users)
  map.put("yes", Res.string.yes)
}
